'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

import GenderSelection from './GenderSelection';
import AgeCategorySelection from './AgeCategorySelection';
import { ageCategoryUrl } from 'src/services/route-utils';

type Props = { sex?: string; ageCategory?: string; ageCategories: any[] };

export default function PageForm({ sex, ageCategory, ageCategories }: Props) {
    const router = useRouter();

    useEffect(() => {
        let scrollTo = 'gender-selection';
        if (ageCategory) {
            scrollTo = 'tests-container';
        } else if (sex) {
            scrollTo = 'age-category-selection';
        }
        document.getElementById(scrollTo)?.scrollIntoView();
    }, [sex, ageCategory]);

    const handleSex = (sex: string) => {
        handleRoute(sex);
    };

    const handleAgeCategory = (ageCategory: string) => {
        handleRoute(sex, ageCategory);
    };

    const handleRoute = (sex?: string, ageCategory?: string) => {
        const parts = [ageCategoryUrl(null)];
        if (sex) {
            parts.push(sex);
        }
        if (ageCategory) {
            parts.push(ageCategory);
        }

        router.replace(parts.join('/'), { scroll: false });
    };

    return (
        <>
            <GenderSelection selected={sex} onSelect={handleSex} />
            {!!ageCategories?.length && (
                <AgeCategorySelection items={ageCategories} selected={ageCategory} onSelect={handleAgeCategory} />
            )}
        </>
    );
}
